import { render, staticRenderFns } from "./SignatureCreateRequestView.vue?vue&type=template&id=12d36525"
import script from "./SignatureCreateRequestView.vue?vue&type=script&lang=js"
export * from "./SignatureCreateRequestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports